// extracted by mini-css-extract-plugin
module.exports = {"bb-activism-webform":"bb-activism-webform__EG_cl","bb-activism-webform__content-wrapper":"bb-activism-webform__content-wrapper__MxF3h"};